module.exports = __webpack_public_path__ + "img/u67.88fe13d0.png";